module.exports = __webpack_public_path__ + "static/tipsAndTricksBack-d528b4bcb5c1cd1d578c1e0a601c9e84.png";